import { Moment } from "moment";
import Guid from "common/values/guid/guid";
import FeeScheduleTag from "work/values/fee-schedule-tag/fee-schedule-tag";
import EntityRepresentative from "work/entities/entity-representative/entity-representative";
import FeeScheduleCategory, {
  FeeScheduleCategoryMaskedCurrency
} from "work/values/fee-schedule-category/fee-schedule-category";

export default class FeeScheduleTemplate {
  id?: Guid;
  createdDate?: Moment;
  creator?: EntityRepresentative;
  name: string;
  tags: FeeScheduleTag[] = [];
  categories: FeeScheduleCategory[] | FeeScheduleCategoryMaskedCurrency[] = [];

  archivedDate: Moment | null;
  isExpanded: boolean | undefined;

  constructor(
    name: string, id?: Guid,
    tags?: FeeScheduleTag[],
    categories?: FeeScheduleCategory[] | FeeScheduleCategoryMaskedCurrency[],
    archivedDate?: Moment
  ) {
    this.name = name;
    this.id = id;
    this.tags = tags ?? [];
    this.categories = categories ?? [];
    this.archivedDate = archivedDate ?? null;
  }

  public isUsing(categories: FeeScheduleCategory[] | FeeScheduleCategoryMaskedCurrency[]): boolean {
    return categories.some((category) => {
      return this.categories.some((thisCategory) => category.id.isEqualTo(thisCategory.id));
    });
  }
}
